module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAAAXNSR0IArs4c6QAAAL9JREFUSEvtl7ENAjEMRb89A7SAYAEGiZJMcQ1sg0TBFskkLACClrsZbERHwykXToSTktr2d56/5IRQ4FCOpvf+oKp7AMcQwm5ojSxRa+2FiNaqeo0xbn4i6py7AVgCuIcQVlX0E4GsmVa8qYaqeHtJTdNIxpgFM2+ZmVONICInIpqrasvMzYA8EZEzOedaALPUxBHiOrLWPl5dj1AstURHRfCmtvceN0331pv2EagzTfVHXW3/t9qKPLa//VY8AdN/q9K3CIEtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/add_default.png
// module id = NPFe
// module chunks = 3